<jhi-alert></jhi-alert>
<jhi-spinner *ngIf="loading"></jhi-spinner>
<div class="col-xl">
    <div class="card-wrapper">
        <div class="card">
            <div class="card-body" [ngClass]="noStyle ? 'px-0' : ''">
                <div class="row justify-content-center text-center">
                    <div class="col-lg-12 mb-3">
                        <div class="card card-flex no-after rounded mb-0 font-philosopher" [ngClass]="noStyle ? '' : 'shadow-sm border border-light px-3'" style="justify-content: space-around;">
                            <div class="card-image-wrapper with-read-more" *ngIf="pagamento">
                                <div class="card-body pb-0" [ngClass]="noStyle ? 'px-0' : ''">
                                    <h3 class="card-title h5 mb-4" *ngIf="!noStyle">Dati
                                        Pagamento</h3>
                                    <div class="card border-black">
                                        <div class="form-group row" *ngIf="pagamento.Tributo">
                                            <div class="col-4">
                                                <label for="nomeUtente" class="active">Tributo</label>
                                                <input disabled readonly id="nomeUtente" class="form-control" type="text" value="{{pagamento.Tributo}}">
                                            </div>
                                            <div class="col-4">
                                                <label for="cognomeUtente" class="active">Data scadenza</label>
                                                <input disabled readonly id="cognomeUtente" class="form-control" type="text" value="{{pagamento.Data | date: 'dd/MM/yyyy'}}">
                                            </div>
                                          <div class="col-4">
                                            <label for="emailUtente" class="active">Numero avviso</label>
                                            <input disabled readonly id="emailUtente" class="form-control" type="text" value="{{pagamento.Iuv}}">
                                          </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="descrizione" class="active">Descrizione</label>
                                            <input disabled readonly id="descrizione" class="form-control" type="text" value="{{pagamento.Descrizione}}">
                                        </div>
                                        <div class="form-group row">
                                          <div class="col-3">
                                            <label for="tipo" class="active">Tipo</label>
                                            <input disabled readonly id="tipo" class="form-control" type="text" value="{{pagamento.Tipo}}">
                                          </div>
                                          <div class="col-3">
                                            <label for="stato" class="active">Stato</label>
                                            <input disabled readonly id="stato" class="form-control" type="text" value="{{pagamento.stato}}">
                                          </div>
                                          <div class="col-6" *ngIf="!pagamento.Tributo">
                                            <label for="dtScad" class="active">Data scadenza</label>
                                            <input disabled readonly id="dtScad" class="form-control" type="text" value="{{pagamento.Data | date: 'dd/MM/yyyy'}}">
                                          </div>
                                        </div>
                                      <div style="justify-content: center; display: flex" *ngIf="pagamento.PdfPagopa">
                                        <div class="col-lg-6">
                                          <button class="btn btn-primary" (click)="downloadPdf(pagamento.PdfPagopa)">Scarica avviso<svg class="icon icon-white icon-sm ms-1"><use href="content/svg/sprites.svg#it-file-pdf"></use></svg></button>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Dettaglio rate -->
            <div class="row justify-content-center mb-5 pb-5">
                <div *ngIf="pagamento && pagamento.Rate && pagamento.Rate.length" class="col-lg-11">
                    <h4 class="text-center fw-bold">Lista rate</h4>
                    <div class="card-wrapper d-flex justify-content-center" style="padding-bottom: 0">
                        <div class="card card-bg border-bottom-card">
                            <div class="card-body">
                                <div class="table-responsive" style="overflow-x: hidden">
                                    <table class="table table-striped">
                                        <caption hidden>Tabella lista pagamenti</caption>
                                        <thead>
                                        <tr>
                                            <th scope="col" class="text-center">Descrizione</th>
                                            <th scope="col" class="text-center">Importo</th>
                                            <th scope="col" class="text-center">IUV</th>
                                            <th scope="col" class="text-center" *ngIf="isPdfPagoPaPresent">Avviso pagoPa</th>
                                            <th scope="col" class="text-center">Azioni</th>
                                        </tr>
                                        </thead>
                                        <tbody *ngIf="pagamento.Rate">
                                        <tr *ngFor="let rata of pagamento.Rate; index as i">
                                            <td class="text-center" *ngIf="rata.Descrizione">{{rata.Descrizione}}</td>
                                            <td class="text-center" *ngIf="!rata.Descrizione">-</td>
                                            <td class="text-center">{{ rata.Importo | currency : 'EUR'}}</td>
                                            <td class="text-center" *ngIf="rata.Iuv">{{rata.Iuv}}</td>
                                            <td class="text-center" *ngIf="!rata.Iuv">-</td>
                                            <td class="text-center" *ngIf="rata.PdfPagopa">
                                                <button class="button c-pointer centered"
                                                        (click)="downloadPdf(rata.PdfPagopa)">
                                                    <div class="button-wrapper position-relative">
                                                        <div class="text fw-bold" jhiTranslate="certificazioniEmesseTableTh.scarica">Scarica</div>
                                                        <span class="icon-download">
                              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="10px"
                                   height="10px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                      stroke-width="2"
                                      d="M12 15V3m0 12l-4-4m4 4l4-4M2 17l.621 2.485A2 2 0 0 0 4.561 21h14.878a2 2 0 0 0 1.94-1.515L22 17"></path>
                              </svg>
                            </span>
                                                    </div>
                                                </button>
                                            </td>
                                            <td class="text-center" *ngIf="pagamento.stato === 'F24 da Stampare' || pagamento.stato === 'Pagato' || rata.RataPagamenti || !rata.Iuv">-</td>
                                            <td class="text-center position-relative" *ngIf="pagamento.stato !== 'Pagato' && pagamento.stato !== 'F24 da Stampare' && !rata.RataPagamenti && rata.Iuv">
                                                <button class="button c-pointer primary-button centered" (click)="paga(rata)">
                                                    <div class="button-wrapper position-relative">
                                                        <div class="text fw-bold" jhiTranslate="pagamenti.paga">Paga</div>
                                                        <span class="icon-download">
                              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-primary grow" id="Icons"
                                   viewBox="0 0 32 32">
                          <style type="text/css">
                            .st0 {
                                fill: none;
                                stroke: white;
                                stroke-width: 2;
                                stroke-linecap: round;
                                stroke-linejoin: round;
                                stroke-miterlimit: 10;
                            }

                            .st3 {
                                fill: none;
                            }
                          </style>
                          <path class="st0"
                                d="M19.7,26.8c-0.9-0.9-1.1-2.2-0.7-3.3l-3.3-3.3c-1.6-1.6-1.5-4.4,0.3-6.2l0,0l5,5"/>
                          <path class="st0" d="M12.7,26.3c0.6,0.7,1.3,1.3,2.1,1.7c0.7,0.4,1.2,1.2,1.2,2v0"/>
                          <path class="st0" d="M18,24H8c-1.1,0-2-0.9-2-2V5c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2v13"/>
                          <line class="st0" x1="10" y1="3" x2="10" y2="24"/>
                          <line class="st0" x1="16" y1="6" x2="16" y2="10"/>
                          <path class="st0" d="M25,30v-9.5c0-3.3-2-6.2-5-7.4"/>
                          <rect x="-144" y="-216" class="st3" width="536" height="680"/>
                        </svg>
                            </span>
                                                    </div>
                                                </button>
                                            </td>
                                            <td class="text-center" *ngIf="rata.RataPagamenti">-</td>
                                            <td class="text-center" *ngIf="!rata.RataPagamenti && !rata.Iuv">-</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
